//https://github.com/bsdfzzzy/vue2-hammer
//use v-touch-event-handle and attribute [touch-event-type]

import Hammer from 'hammerjs';

const gestures = ['tap', 'pan', 'pinch', 'press', 'rotate', 'swipe'];
const subGestures = ['panstart', 'panend', 'panmove', 'pancancel', 'pinchstart', 'pinchmove', 'pinchend', 'pinchcancel', 'pinchin', 'pinchout', 'pressup', 'rotatestart', 'rotatemove', 'rotateend', 'rotatecancel'];
const directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];

var config = {};
var customEvents = {
  'doubletap': {
    event: 'doubletap',
    type: 'tap',
    taps: 2
  }
};

const guardDirections = (options) => {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-hammer] invalid direction: ' + dir);
    }
  }
};

const buildEventWithDirections = (eventName, directionArray) => {
  const f = {};
  directionArray.forEach(dir => {
    dir = dir.toLowerCase();
    if (dir === 'horizontal') {
      f.left = 1;
      f.right = 1;
    } else if (dir === 'vertical') {
      f.up = 1;
      f.down = 1;
    } else if (dir === 'all') {
      f.left = 1;
      f.right = 1;
      f.up = 1;
      f.down = 1;
    } else {
      f[dir] = 1;
    }
  });

  const _directionArray = Object.keys(f);

  if (_directionArray.length === 0) {
    return eventName;
  }

  const eventWithDirArray = _directionArray.map(dir => {
    return eventName + dir;
  });

  return eventWithDirArray.join(' ');
};

const capitalize = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const applyDirective = (el, binding) => {
  if (!el.hammer) {
    el.hammer = new Hammer.Manager(el);
  }
  const mc = el.hammer;

  // determine event type
  const event = binding.arg || el.getAttribute('touch-event-type');
  if (!event) {
    console.warn('[vue-hammer] event type argument is required.');
  }

  el.__hammerConfig = el.__hammerConfig || {};
  el.__hammerConfig[event] = {};

  const direction = binding.modifiers;

  el.__hammerConfig[event].direction = el.__hammerConfig[event].direction || [];

  if (Object.keys(direction).length) {
    Object.keys(direction)
      .filter(keyName => binding.modifiers[keyName])
      .forEach(keyName => {
        const elDirectionArray = el.__hammerConfig[event].direction;
        if (elDirectionArray.indexOf(keyName) === -1) {
          elDirectionArray.push(String(keyName));
        }
      });
  }

  let recognizerType, recognizer;

  if (customEvents[event]) {
    // custom event
    const custom = customEvents[event];
    recognizerType = custom.type;
    recognizer = new Hammer[capitalize(recognizerType)](custom);
    recognizer.recognizeWith(mc.recognizers);
    mc.add(recognizer);
  } else {
    // built-in event
    recognizerType = gestures.find(gesture => gesture === event);
    const subGesturesType = subGestures.find(gesture => gesture === event);
    if (!recognizerType && !subGesturesType) {
      console.warn('[vue-hammer] invalid event type: ' + event);
      return;
    }
    if (subGesturesType && el.__hammerConfig[subGesturesType].direction.length !== 0) {
      console.warn('[vue-hammer] ' + subGesturesType + ' should not have directions');
    }
    if (!recognizerType) {
      return;
    }
    if (recognizerType === 'tap' || recognizerType === 'pinch' || recognizerType === 'press' || recognizerType === 'rotate') {
      if (el.__hammerConfig[recognizerType].direction.length !== 0) {
        throw Error('[vue-hammer] ' + recognizerType + ' should not have directions');
      }
    }
    recognizer = mc.get(recognizerType);
    if (!recognizer) {
      // add recognizer
      recognizer = new Hammer[capitalize(recognizerType)]();
      // make sure multiple recognizers work together...
      recognizer.recognizeWith(mc.recognizers);
      mc.add(recognizer);
    }
    // apply global options
    const globalOptions = config[recognizerType];
    if (globalOptions) {
      guardDirections(globalOptions);
      recognizer.set(globalOptions);
    }
    // apply local options
    var localOptions = el.hammerOptions &&
      el.hammerOptions[recognizerType];
    if (localOptions) {
      guardDirections(localOptions);
      recognizer.set(localOptions);
    }
  }
}

const TouchDirective = {
  bind: (el, binding) => {
    applyDirective(el,binding);
  },

  inserted: (el, binding) => {
    const mc = el.hammer;
    const event = binding.arg || el.getAttribute('touch-event-type');
    const eventWithDir = subGestures.find(subGes => subGes === event) ? event : buildEventWithDirections(event, el.__hammerConfig[event].direction);
    if (mc.handler) {
      mc.off(eventWithDir, mc.handler);
    }
    if (typeof binding.value !== 'function') {
      mc.handler = null;
      console.warn(
        '[vue-hammer] invalid handler function for v-hammer: ' +
        binding.arg
      );
    } else {
      mc.on(eventWithDir, (mc.handler = binding.value));
    }
  }
};

export default TouchDirective;
